import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasTemplateDirective } from './gas-template.directive';

const DIRECTIVES = [
  GasTemplateDirective,
];

// todo: перенести в пакет с утилитами
@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    DIRECTIVES,
  ],
})
export class GasTemplateModule { }
